<script lang="ts">
import EnterprisePage from "./enterprise-page.svelte";
</script>

<EnterprisePage />
